import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import comparisonPages from '../../data/comparePages';
import ComparisonPageTemplate from './ComparisonPageTemplate';

const ComparisonPage = () => {
  const { competitorSlug } = useParams();
  const data = comparisonPages[competitorSlug];

  if (!data) {
    return <Navigate to="/compare" replace />;
  }

  const siblingComparisons = Object.values(comparisonPages).filter(
    (item) => item.slug !== competitorSlug,
  );

  return <ComparisonPageTemplate data={data} siblingComparisons={siblingComparisons} />;
};

export default ComparisonPage;
